"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _vueSvgicon = _interopRequireDefault(require("vue-svgicon"));
/* eslint-disable */
/* tslint:disable */
// @ts-ignore

_vueSvgicon.default.register({
  'drag': {
    width: 512,
    height: 512,
    viewBox: '0 0 512 512',
    data: '<path pid="0" d="M80 304h352v16H80zM80 248h352v16H80zM80 192h352v16H80z"/>'
  }
});